// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entities_card_footer-module__container--2U4-r{background-color:#fff;border-top:1px solid #e7ebef;padding:16px 24px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}\n", ""]);
// Exports
exports.locals = {
	"container": "entities_card_footer-module__container--2U4-r"
};
module.exports = exports;
